import type { Manufacturer, ServiceObjectsInfoMode } from 'common/models';
import { LabeledText } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { ServiceObjectInCustomer } from 'pages/serviceObjects/models';
import React from 'react';

import ServiceObjectsInfoTable from './ServiceObjectsInfoTable';

interface Props {
  title?: string;
  serviceObjects: ServiceObjectInCustomer[];
  mode?: ServiceObjectsInfoMode;
  serviceObjectManufacturers: Manufacturer[];
}

const ServiceObjectsInfoBlock: React.FC<Props> = (props): React.ReactElement => {
  const { title, serviceObjects, mode, serviceObjectManufacturers } = props;

  const { t } = useCustomTranslation();

  if (mode === 'table') {
    return (
      <ServiceObjectsInfoTable
        title={title}
        serviceObjectManufacturers={serviceObjectManufacturers}
        serviceObjects={serviceObjects}
      />
    );
  }

  // default return 'count'
  return (
    <LabeledText
      label={title || t('customData.serviceObjectsCount')}
      value={serviceObjects.length}
    />
  );
};

export default ServiceObjectsInfoBlock;
